/**
 *
 *
 *
 *
 *
 *
 */
import { otto } from "@gr-exports/async/nexus";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 */
export const viewport = asExport(otto, "viewport", {});
/**
 *
 *
 *
 *
 *
 */
export const currentBreakpoint = asExport(viewport, "currentBreakpoint", {});
/**
 *
 *
 *
 *
 */
export const isActiveBreakpoint = asExport(viewport, "isActiveBreakpoint", noop);
/**
 *
 *
 *
 */
export const getCurrentBreakpoint = asExport(viewport, "getCurrentBreakpoint", noop);
/**
 *
 *
 *
 */
export const currentOrientation = asExport(viewport, "currentOrientation", {});
/**
 *
 *
 */
export const isActiveOrientation = asExport(viewport, "isActiveOrientation", noop);
/**
 *
 */
export const getCurrentOrientation = asExport(viewport, "getCurrentOrientation", noop);
/**
 *
 *
 */
export const getScrollbarWidth = asExport(viewport, "getScrollbarWidth", noop);
